import React from 'react';
import { Button } from 'components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';
import { NavItemData } from './sidebarNavItems';
import { cn } from 'lib/utils';

/**
 * Pieza del Sidebar: una fila de navegación. Ver SidebarNav.tsx para la
 * lista completa y Sidebar.tsx para la composición.
 */
export interface SidebarNavItemProps {
	item: NavItemData;
	isActive: boolean;
	isMenuOpen: boolean;
	/** Al pulsar la sección, con su ruta. */
	onNavigate?: (route: string) => void;
}

export const SidebarNavItem = ({ item, isActive, isMenuOpen, onNavigate }: SidebarNavItemProps) => (
	<TooltipProvider delayDuration={0}>
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					// 🔴 La sección activa se marcaba SOLO con una clase: quien no ve la pantalla
					// no tenía forma de saber dónde está. La barra de móvil de chirigota ya lo
					// hacía bien (`MobileBottomNavV2.tsx`), y este bloque viene a sustituirla.
					aria-current={isActive ? 'page' : undefined}
					// Por su ruta la encuentran los e2e de la aplicación (`nav-tab-<route>`).
					data-testid={`nav-tab-${item.route}`}
					// Plegada, la fila es solo el icono: sin esto no tendría nombre (axe, button-name).
					aria-label={isMenuOpen ? undefined : item.label}
					onClick={() => onNavigate?.(item.route)}
					variant="ghost"
					className={cn(
						'w-full relative h-auto justify-start gap-3 rounded-control px-4 py-3 font-heading text-sidebar-foreground transition-all duration-200 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
						isActive
							? 'bg-sidebar-accent text-sidebar-accent-foreground font-medium'
							: 'font-normal',
						!isMenuOpen && 'justify-center px-2'
					)}
				>
					<span className="flex items-center justify-center w-7 h-7 shrink-0">{item.icon}</span>
					{isMenuOpen && <span>{item.label}</span>}
				</Button>
			</TooltipTrigger>
			{!isMenuOpen && <TooltipContent side="right">{item.label}</TooltipContent>}
		</Tooltip>
	</TooltipProvider>
);
